import React from 'react'
import { BiX } from 'react-icons/bi'
import { Modal } from '@mui/material'
import { semFoto } from '../../../assets'
import { AuthContext } from '../../../contexts/AuthContext'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'

import './stylesMA.css'

export default function ModalAnuncio({ show, ClosedModal, anuncio }) {
  const { sttAuthCtx } = React.useContext(AuthContext)

  return (
    <Modal open={show} onClose={ClosedModal} className='contain-overlay-anuncios'>
      <div className='contain-comp-modal-anuncios'>
        {!sttAuthCtx.isMobile ? (
          <BiX
            className='icon-close-modal'
            onClick={() => ClosedModal()}
            style={{ margin: 'var(--margin-low) var(--margin-low) 0px 0px' }}
            size={30}
            color={'white'}
          />
        ) : (
          <button className='btt-close-modal-anuncios' onClick={() => ClosedModal()} title='Fechar modal'>
            <ArrowBackIosIcon
              className='icon-close-modal-anuncios'
              onClick={() => {
                ClosedModal()
              }}
              title='Voltar para a página de login'
            />
          </button>
        )}
        <img
          alt='Anúncio'
          src={anuncio.foto}
          onError={e => {
            e.target.onerror = null
            e.target.src = { semFoto }
          }}
        />
        <div className='contain-details-anuncios'>
          <h2>{anuncio.titulo}</h2>
          <p>{anuncio.texto}</p>
          {anuncio.link && (
            <button
              className='btt-action-anuncios'
              onClick={() => {
                window.open(anuncio.link, '_blank')
              }}
            >
              {anuncio.textoLink ? anuncio.textoLink : 'Avaliar!'}
            </button>
          )}
        </div>
      </div>
    </Modal>
  )
}
